import React from "react";
import { MainLayoutTemplate } from "themes/common/layouts";

function MainLayout(props) {
    return <MainLayoutTemplate {...props} />;
}

export default MainLayout;
